export class BotValidationConfiguration {
  botValidationConfigId: any;
  botValidationConfigStatus: any;
  fkBotResponseId: any;
  validationFor: any;
  validationType: any;
  minCheck: any;
  maxCheck: any;
}
